
import './App.scss';
import RoutePaths from './routes/routes';
function App() {
  return (
    <div className="App">
      <RoutePaths/>

    </div>
  );
}

export default App;
